export default {
    produtos: [],
    produto: {},
    ultimaAtualizacaoLista: null,
    listaCompletaCarregada: false
}
